import * as React from "react";
import {Edit} from 'react-admin';
import {useParams} from "react-router-dom";
import ReservationForm from "./ReservationForm";


const ReservationEdit = props => {
    const {id} = useParams();
    
    return (
        <Edit basePath={`/`} resource={`reservations`} id={id}>
           <ReservationForm {...props}/>
        </Edit>
    );
};

export default ReservationEdit;
